import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import { SvgIconProps } from '@mui/material/SvgIcon';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import isEmpty from 'lodash/isEmpty';
import { useMutation, useQuery } from 'urql';

import { Property } from '../../../../Graphql/Generated/graphql';
import { LIKE_PROPERTY, UNLIKE_PROPERTY } from '../../../../Graphql/mutations';
import { IS_PROPERTY_LIKED } from '../../../../Graphql/queries';
import { formatUsd } from '../../../../Utils/GenericFunctions';
import ImageLoader from '../../../../legacy/Components/Generics/Image';
import { HeartIcon } from '../../../icons/heartIcon';
import { Star } from '../icons/star';

export const RoundedCard = styled(Card)`
  border-radius: 15px 15px 0 0;
  box-shadow: none;
  cursor: pointer;
`;

export const PropertyMedia = styled(CardMedia)`
  height: 290px;
`;

export const PropertyImage = styled(ImageLoader)`
  width: 100%;
  object-fit: cover;
  position: relative;
`;

export const ContentTitle = styled('div')`
  display: flex;
  justify-content: space-between;
`;

export const PropertyCardContent = styled(CardContent)`
  padding: 15px 0 15px 0;
`;

// TODO: image container
const ImageContainer = styled('div')`
  cursor: pointer;
  position: relative;
  bottom: 280px;
  left: 250px;

  @media (max-width: 600px) {
    position: relative;
    left: 315px;
    bottom: 270px;
  }
`;

export interface LikedImageProps extends SvgIconProps {
  liked: boolean;
}

// const PropertyLikeIcon = styled(HeartIcon)<LikedImageProps>`
//   fill: ${(props) => (props.liked ? '#DB5769' : 'white')};
// `;

export interface IListingsProps {
  width?: number;
  height?: number;
  property: Property;
}

export const PropertyCard = ({ property, width = 300, height = 290 }: IListingsProps) => {
  const navigate = useNavigate();
  const [liked, setLiked] = useState(false);

  // TODO: Redux store
  // TODO: Redux Query
  const likePropertyMutationVariables = {
    propertyId: property.id,
    userId: !isEmpty(sessionStorage.getItem('userId')) ? sessionStorage.getItem('userId') : '',
  };

  const [, likePlace] = useMutation(LIKE_PROPERTY);
  const [, unlikePlace] = useMutation(UNLIKE_PROPERTY);

  const handleLikedChange = () => {
    if (liked) {
      unlikePlace(likePropertyMutationVariables);
    } else {
      likePlace(likePropertyMutationVariables);
    }
    setLiked(!liked);
  };

  const [result] = useQuery({
    query: IS_PROPERTY_LIKED,
    variables: {
      propertyId: property.id,
      userId: sessionStorage.getItem('userId'),
    },
    pause: isEmpty(sessionStorage.getItem('userId')),
  });

  useEffect(() => {
    if (!result.error && result.data) {
      setLiked(result.data.isPropertyLiked);
    }
  }, [result.error, result.data]);

  const urlSafeTitle = property.name;

  return (
    <RoundedCard key={property.id}>
      <PropertyMedia title={`${property?.name} image`}>
        <PropertyImage
          // @ts-ignore
          onClick={() => navigate(`/property/${urlSafeTitle}`, { state: property })}
          width={width}
          height={height}
          filename={property?.images?.[0] || ''}
          // src={property?.src} // TODO: We want the image src on the property
          place={property}
          loading='lazy'
        />
        <ImageContainer onClick={handleLikedChange}>
          <HeartIcon liked={liked} />
        </ImageContainer>
      </PropertyMedia>
      <PropertyCardContent>
        <ContentTitle>
          <Typography variant='body1' component='div' fontWeight='bold'>
            {property.title}, {property.city}
          </Typography>
          <Typography variant='body1' component='div'>
            <Star />
            {/* Rating does not exist yet */}
            {/* {property?.rating} */}
          </Typography>
        </ContentTitle>

        <Typography variant='body2' color='text.secondary' component='div'>
          {property?.rooms} Beds, {property?.baths} Bath
        </Typography>
        {property.monthRent?.length ? (
          <Typography variant='body2'>
            From {formatUsd(Math.min(...property.monthRent))} Per Month
          </Typography>
        ) : (
          <Typography variant='body2'>{formatUsd(property?.totalRent)} Per Month</Typography>
        )}
      </PropertyCardContent>
    </RoundedCard>
  );
};
